// ── Firebase Initialization ─────────────────────────────────────────
// Point 2: Firebase auth — initialize the app and export auth instance

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const readFirebaseEnv = (value) =>
  String(value || "")
    .trim()
    .replace(/^["']/, "")
    .replace(/,\s*$/, "")
    .replace(/["']$/, "");

const firebaseConfig = {
  apiKey: readFirebaseEnv(process.env.REACT_APP_FIREBASE_API_KEY),
  authDomain: readFirebaseEnv(process.env.REACT_APP_FIREBASE_AUTH_DOMAIN),
  projectId: readFirebaseEnv(process.env.REACT_APP_FIREBASE_PROJECT_ID),
  appId: readFirebaseEnv(process.env.REACT_APP_FIREBASE_APP_ID),
};

const missingFirebaseValues = Object.entries(firebaseConfig)
  .filter(([, value]) => !value)
  .map(([key]) => key);

if (missingFirebaseValues.length > 0) {
  throw new Error(
    `Missing Firebase configuration: ${missingFirebaseValues.join(", ")}`
  );
}

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Export auth instance — used everywhere for phone sign-in
export const auth = getAuth(app);

export default app;
